import React from 'react';

const IconMarker = ({ onClick }) => {
	return (
		<div className='IconMarker' onClick={onClick}>
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_137_2657)">
					<circle cx="10" cy="10" r="10" fill="white" />
					<path fillRule="evenodd" clipRule="evenodd" d="M4.16675 7.49984C4.16675 4.27484 6.77508 1.6665 10.0001 1.6665C13.2251 1.6665 15.8334 4.27484 15.8334 7.49984C15.8334 11.8748 10.0001 18.3332 10.0001 18.3332C10.0001 18.3332 4.16675 11.8748 4.16675 7.49984ZM11.3563 8.03129H11.7176L14.0001 10.3183L13.3186 10.9998L11.0315 8.71739V8.35604L10.908 8.22797C10.3866 8.67623 9.70963 8.94609 8.97321 8.94609C8.38518 8.94609 7.81036 8.77172 7.32143 8.44503C6.8325 8.11834 6.45143 7.654 6.2264 7.11073C6.00137 6.56747 5.94249 5.96967 6.05721 5.39294C6.17193 4.81621 6.45509 4.28645 6.87089 3.87065C7.28669 3.45485 7.81645 3.17169 8.39318 3.05697C8.96991 2.94225 9.56771 3.00113 10.111 3.22616C10.6542 3.45119 11.1186 3.83226 11.4453 4.32119C11.772 4.81012 11.9463 5.38494 11.9463 5.97297C11.9468 6.68318 11.692 7.36989 11.2282 7.90779L11.3563 8.03129Z" fill="#344050" />
				</g>
				<defs>
					<clipPath id="clip0_137_2657">
						<rect width="20" height="20" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</div>
	)
}

export default IconMarker;